import "./index.css";

const ValidationMessage = ({ message }) => {
  return <p className="validationMessage">{message}</p>;
};

export default ValidationMessage;
